import { frontendURL } from '../../helper/URLHelper';

const MetricsIndex = () => import('./Index.vue');
const MetricsOverview = () =>
  import('./components/overview/MetricsOverview.vue');
const MetaAdsPage = () => import('./components/meta/MetaAdsPage.vue');
const GoogleAdsPage = () => import('./components/google/GoogleAdsPage.vue');
const SalesPage = () => import('./components/sales/SalesPage.vue');

const commonMeta = {
  permissions: ['administrator', 'agent'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/metrics'),
    component: MetricsIndex,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'metrics_overview',
        component: MetricsOverview,
        meta: commonMeta,
      },
      {
        path: 'meta',
        name: 'metrics_meta',
        component: MetaAdsPage,
        meta: commonMeta,
      },
      {
        path: 'google',
        name: 'metrics_google',
        component: GoogleAdsPage,
        meta: commonMeta,
      },
      {
        path: 'sales',
        name: 'metrics_sales',
        component: SalesPage,
        meta: commonMeta,
      },
    ],
  },
];
